import { EditFilled } from '@ant-design/icons';
import { Button, Card, Space } from 'antd';
import { useState } from 'react';

import { ShiftListItemDto } from '@clh/api-client';

import { useSelection } from '../../../hooks/use-selection';
import ObjectPropertyList from '../../../record-details/object-property-list';

import { AuthorizationChecker } from './authorization-checker';
import { CancellationDetails } from './cancellation-details';
import { LogTime } from './log-time';
import { NurseCancellationsTable } from './nurse-cancellations-table';
import { createNurseProfileFieldRenderer } from './nurse-profile-field';
import { createPayRateFieldRenderer } from './pay-rate-field';
import { createStipendsFieldRenderer } from './stipends-field';
import { SubmittedTimeSummary } from './submitted-time-field';

export default function AssignmentTab() {
    const { selection } = useSelection<ShiftListItemDto>();
    const [editAssignedNurse, setEditAssignedNurse] = useState(false);
    const [editPayRate, setEditPayRate] = useState(false);
    const [editMinutesWorked, setEditMinutesWorked] = useState(false);
    const [addingStipend, setAddingStipend] = useState(false);

    const hasTimeSubmitted = !!(
        selection.minutesWorked || selection.onCallShift?.minutesWorked
    );
    const editButtonLabel = hasTimeSubmitted ? (
        <>
            Edit <EditFilled />
        </>
    ) : (
        'Submit Time'
    );

    return (
        <Space direction="vertical" style={{ width: '100%' }} size="large">
            <Card
                title={editMinutesWorked ? 'Submit Time' : 'Submitted Time'}
                size="small"
                extra={
                    selection.nurseProfile && !editMinutesWorked ? (
                        <Button
                            type="link"
                            onClick={() => setEditMinutesWorked(true)}
                        >
                            {editButtonLabel}
                        </Button>
                    ) : null
                }
            >
                {editMinutesWorked ? (
                    <LogTime close={() => setEditMinutesWorked(false)} />
                ) : (
                    <SubmittedTimeSummary selection={selection} />
                )}
            </Card>

            <ObjectPropertyList
                values={{
                    ...selection,
                }}
                fields={{
                    nurseProfile: createNurseProfileFieldRenderer(
                        editAssignedNurse,
                        () => setEditAssignedNurse(true),
                        () => setEditAssignedNurse(false)
                    ),
                    payRate: createPayRateFieldRenderer(
                        selection,
                        editPayRate,
                        () => setEditPayRate(true),
                        () => setEditPayRate(false)
                    ),
                    stipends: createStipendsFieldRenderer(
                        selection,
                        addingStipend,
                        () => setAddingStipend(true),
                        () => setAddingStipend(false)
                    ),
                    submittedTimeAt: true,
                }}
            />

            <CancellationDetails selection={selection} />

            <NurseCancellationsTable selection={selection} />

            <AuthorizationChecker />
        </Space>
    );
}
